/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Mantine
import {
	Tabs as NativeTabs,
	Box,
	Group,
} from '@mantine/core';

// Styles
import classes from './Onglet.module.css';

/* -------------------------------------------------------------------------- */
/*                                   Types                                    */
/* -------------------------------------------------------------------------- */
type OngletItem = {
	id: string;
	label: string;
	value: string;
	nbr: number | null;
	disabled?: boolean;
};

type OngletProps = {
	items: OngletItem[];
	onChange: (value: string | null) => void;
};

/* -------------------------------------------------------------------------- */
/*                                Component                                */
/* -------------------------------------------------------------------------- */
export const Onglet = (props: OngletProps) => {
	const { items, onChange } = props;
	return (
		<NativeTabs
			onChange={onChange}
			classNames={classes}
			defaultValue={items[0].value}
		>
			<NativeTabs.List grow justify="center">
				{items.map((item) => (
					<NativeTabs.Tab
						key={item.id}
						value={item.value}
						disabled={item.disabled}
					>
						{item.nbr == null ? (
							item.label
						) : (
							<Group gap="7px">
								{item.label}
								<Box className={classes.containerTotal}>
									{item.nbr}
								</Box>
							</Group>
						)}
					</NativeTabs.Tab>
				))}
			</NativeTabs.List>
		</NativeTabs>
	);
};
